
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/schools/refer-a-school/thank-you",
      function () {
        return require("private-next-pages/schools/refer-a-school/thank-you/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/schools/refer-a-school/thank-you"])
      });
    }
  